import { Box, styled } from "@chakra-ui/react"

// NOTE: requires a parent with a "group" class.
// Reveals itself (using opacity) when the parent "group" is hovered.
// Always revealed on mobile.
const RevealOnGroupHover = styled(Box, {
  baseStyle: {
    opacity: 0,
    transition: "opacity 0.2s ease-in-out",
    _groupHover: {
      opacity: 1
    },
    sx: {
      "@media (hover: none)": {
        opacity: 1
      }
    }
  }
})

export default RevealOnGroupHover
